import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Projects from "./pages/Projects";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import { getToken } from "./lib/api";
import { SettingsProvider } from "./context/SettingsContext";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function ProtectedRoute({ children }) {
  return getToken() ? children : <Navigate to="/admin" replace />;
}

const withLayout = (el) => <Layout>{el}</Layout>;

function App() {
  return (
    <SettingsProvider>
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={withLayout(<Home />)} />
        <Route path="/about" element={withLayout(<About />)} />
        <Route path="/projects" element={withLayout(<Projects />)} />
        <Route path="/gallery" element={withLayout(<Gallery />)} />
        <Route path="/contact" element={withLayout(<Contact />)} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
    </SettingsProvider>
  );
}

export default App;
